<template>
    <div class="o-view">
      <div class="o-view-bg"></div>
      <div class="o-view-right">
        <div 
          class="otext2 more-line" 
          v-if="defaultlist.value1" 
          ref="autoplay"
          @mouseenter="mouseenterEvent"
          @mouseleave="mouseleaveEvent"
        >
          {{ defaultlist.value1 }}
        </div>
      </div>
    </div>
  </template>
  
  <script>
  import * as methods from "./method.js";
  
  export default {
    name: "template.scope103",
    props: {
      vdata: {
        type: [Array, String],
        default: () => [],
      },
      jsondata: {
        type: [Array, String],
        default: () => [],
      },
      scopedata: {
        type: Object,
        default: () => {},
      },
    },
    data() {
      return {
        defaultdata: [
          {
            value1:
              "2025年2月16日晚19点50分左右，湖北武汉某酒店停车场发生一起暴力事件。三名男子酒后拒绝支付10元停车费，与保安大爷发生争执后，将其抱摔在地并拳打脚踢，过程持续约20秒，导致保安大爷全身多处受伤，包括牙齿脱落、骨折等。目击者陈先生及时报些并制止了打人者，警方当晚将三人控制。目前，被打保安仍在医院接受治疗，酒店方面表示不接受私了，警方正在进一步处理此事。",
          },
        ],
        valueMap: [{ name: "内容", key: "value1" }],
        exceldata: [],
        apiconfig: {},
        isApi: false,
        scope: {},
        config: {},
        timer: null,
        timer1: null,
        iscontact: false,
      };
    },
    computed: {
      defaultlist() {
        return this.defaultdata[0];
      },
    },
    methods: {
      ...methods,
      autoplay() {
        const dom = this.$refs.autoplay;
        // 清除之前的定时器，避免重复设置
        clearInterval(this.timer);
        this.timer = setInterval(() => {
          if (dom.scrollTop >= dom.scrollHeight - dom.clientHeight) {
            clearInterval(this.timer);
            this.timer = null;
            this.timer1 = setTimeout(() => {
              dom.scrollTop = 0;
              this.autoplay();
            }, 2000);
          } else {
            dom.scrollTop += 2;
          }
        }, 150);
      },
      mouseenterEvent() {
        if (this.timer) {
          clearInterval(this.timer);
          this.timer = null;
        }
        if (this.timer1) {
          clearTimeout(this.timer1);
          this.timer1 = null;
        }
      },
      mouseleaveEvent() {
        if (!this.timer) {
          this.autoplay();
        }
      },
    },
    mounted() {
      if (this.vdata && this.vdata.length) {
        this.defaultdata = this.vdata;
      }
      if (this.jsondata && this.jsondata.length) {
        this.exceldata = this.jsondata;
      }
      // 假设 setData 是一个自定义方法，如果不存在可以移除
      this.setData();
      setTimeout(() => {
        this.autoplay();
      }, 200);
    },
    beforeDestroy() {
      clearInterval(this.timer);
      this.timer = null;
      clearTimeout(this.timer1);
      this.timer1 = null;
    },
  };
  </script>
  
  <style lang="scss" scoped>
  .o-view {
    width: 435px;
    height: 240px;
    padding: 10px 0;
    display: flex;
    align-items: center;
  
    .o-view-right {
      padding: 10px 20px;
      box-sizing: border-box;
      // margin-left: 26px;
      height: 240px;
      max-width: 435px;
      color: #fff;
  
      .otext1 {
        font-family: Source Han Sans CN;
        font-weight: 400;
        font-size: 16px;
        line-height: 16px;
      }
  
      .otext2 {
        font-family: Source Han Sans CN;
        font-weight: 400;
        font-size: 14px;
        color: #ffffff;
        line-height: 14px;
        max-width: 100%;
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
        &.more-line {
          line-height: 24px;
          max-width: 100%;
          max-height: 214px;
          overflow-y: auto;
          white-space: normal;
        }
      }
    }
  
    .o-view-bg {
      width: 429px;
      height: 230px;
      position: absolute;
      border-bottom: 2px solid #2d8dff;
      background: linear-gradient(to top, #0355b1, transparent);
      z-index: -1;
    }
  }
  </style>    